(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hinnankorotus"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const form = root.querySelector('[data-form]');
      const error = root.querySelector('[data-error]');
      const metrics = root.querySelector('[data-metrics]');
      const interpretation = root.querySelector('[data-interpretation]');
      const euro = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
      const percent = new Intl.NumberFormat('fi-FI', { maximumFractionDigits: 1 });

      const parseNumber = (value) => {
        const cleaned = String(value).trim().replace(/\s/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
        return Number(cleaned);
      };

      const setText = (selector, value) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = value;
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const price = parseNumber(root.querySelector('[data-price]').value);
        const variableCost = parseNumber(root.querySelector('[data-variable-cost]').value);
        const quantity = parseNumber(root.querySelector('[data-quantity]').value);
        const increaseRate = parseNumber(root.querySelector('[data-increase]').value);

        if (![price, variableCost, quantity, increaseRate].every(Number.isFinite)) {
          error.textContent = 'Tarkista syöttämäsi luvut. Käytä vain numeroita.';
          error.hidden = false;
          return;
        }
        if (price <= 0 || quantity <= 0) {
          error.textContent = 'Nykyisen hinnan ja myyntimäärän pitää olla suurempia kuin 0.';
          error.hidden = false;
          return;
        }
        if (variableCost < 0 || variableCost >= price) {
          error.textContent = 'Muuttuvan yksikkökustannuksen pitää olla vähintään 0 ja nykyistä myyntihintaa pienempi.';
          error.hidden = false;
          return;
        }
        if (increaseRate <= 0 || increaseRate > 500) {
          error.textContent = 'Hinnankorotuksen pitää olla suurempi kuin 0 ja enintään 500 prosenttia.';
          error.hidden = false;
          return;
        }
        error.hidden = true;

        const newPrice = price * (1 + increaseRate / 100);
        const currentContributionPerUnit = price - variableCost;
        const newContributionPerUnit = newPrice - variableCost;
        const currentContribution = quantity * currentContributionPerUnit;
        const minimumQuantity = currentContribution / newContributionPerUnit;
        const maximumDecreaseRate = (1 - minimumQuantity / quantity) * 100;
        const contributionGain = quantity * (newContributionPerUnit - currentContributionPerUnit);
        const minimumRevenue = minimumQuantity * newPrice;

        setText('[data-new-price]', euro.format(newPrice));
        setText('[data-max-decrease]', `${percent.format(maximumDecreaseRate)} %`);
        setText('[data-min-quantity]', `${percent.format(minimumQuantity)} kpl`);
        setText('[data-contribution-gain]', euro.format(contributionGain));
        setText('[data-result-heading]', `Myyntimäärä voi laskea ${percent.format(maximumDecreaseRate)} %`);

        interpretation.innerHTML =
          `Katetuotto säilyy nykyisellä <strong>${euro.format(currentContribution)}</strong> tasolla, kun uudella hinnalla myydään ` +
          `vähintään <strong>${percent.format(minimumQuantity)} yksikköä</strong>. Tämä vastaa noin ` +
          `<strong>${euro.format(minimumRevenue)}</strong> myyntiä tarkastelujaksolla.`;
        interpretation.hidden = false;
        metrics.hidden = false;

        root.dispatchEvent(new CustomEvent('pahkamaa:calculator-used', {
          bubbles: true,
          detail: { calculator: 'hinnankorotuslaskuri' }
        }));
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-price-calculator]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kannattavuusraja"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const form = root.querySelector('[data-form]');
      const error = root.querySelector('[data-error]');
      const metrics = root.querySelector('[data-metrics]');
      const interpretation = root.querySelector('[data-interpretation]');
      const euro = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
      const percent = new Intl.NumberFormat('fi-FI', { maximumFractionDigits: 1 });

      const parseNumber = (value) => {
        const cleaned = String(value).trim().replace(/\s/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
        return Number(cleaned);
      };

      const setText = (selector, value) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = value;
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const revenue = parseNumber(root.querySelector('[data-revenue]').value);
        const marginRate = parseNumber(root.querySelector('[data-margin]').value);
        const fixedCosts = parseNumber(root.querySelector('[data-fixed-costs]').value);
        const targetEbitda = parseNumber(root.querySelector('[data-target-ebitda]').value);

        if (![revenue, marginRate, fixedCosts, targetEbitda].every(Number.isFinite)) {
          error.textContent = 'Tarkista syöttämäsi luvut. Käytä vain numeroita.';
          error.hidden = false;
          return;
        }
        if (revenue < 0 || fixedCosts < 0 || targetEbitda < 0) {
          error.textContent = 'Liikevaihto, kiinteät kulut ja tavoiteltu käyttökate eivät voi olla negatiivisia.';
          error.hidden = false;
          return;
        }
        if (marginRate <= 0 || marginRate > 100) {
          error.textContent = 'Katetuottoprosentin pitää olla suurempi kuin 0 ja enintään 100.';
          error.hidden = false;
          return;
        }
        error.hidden = true;

        const margin = marginRate / 100;
        const breakEven = fixedCosts / margin;
        const targetRevenue = (fixedCosts + targetEbitda) / margin;
        const currentEbitda = revenue * margin - fixedCosts;
        const safetyMargin = revenue - breakEven;
        const safetyMarginRate = revenue > 0 ? safetyMargin / revenue * 100 : 0;
        const revenueGap = targetRevenue - revenue;

        setText('[data-break-even]', euro.format(breakEven));
        setText('[data-target-revenue]', euro.format(targetRevenue));
        setText('[data-current-ebitda]', euro.format(currentEbitda));
        setText('[data-safety-margin]', `${euro.format(safetyMargin)} (${percent.format(safetyMarginRate)} %)`);

        if (safetyMargin < 0) {
          setText('[data-result-heading]', 'Nykyinen liikevaihto alittaa kannattavuusrajan');
        } else if (revenueGap > 0) {
          setText('[data-result-heading]', 'Toiminta ylittää kannattavuusrajan');
        } else {
          setText('[data-result-heading]', 'Tavoiteltu käyttökate saavutetaan nykyisellä liikevaihdolla');
        }

        if (revenueGap > 0) {
          interpretation.innerHTML =
            `Tavoitekäyttökate edellyttää noin <strong>${euro.format(revenueGap)}</strong> lisää vuosiliikevaihtoa ` +
            `nykyisellä katetuottoprosentilla. Keskimäärin tämä vastaa noin <strong>${euro.format(revenueGap / 12)}</strong> kuukaudessa.`;
        } else {
          interpretation.innerHTML =
            `Nykyinen liikevaihto ylittää tavoitekäyttökatteen vaatiman tason noin ` +
            `<strong>${euro.format(Math.abs(revenueGap))}</strong>. Arvio olettaa katetuottoprosentin ja kiinteiden kulujen pysyvän ennallaan.`;
        }
        interpretation.hidden = false;
        metrics.hidden = false;

        root.dispatchEvent(new CustomEvent('pahkamaa:calculator-used', {
          bubbles: true,
          detail: { calculator: 'kannattavuusrajalaskuri' }
        }));
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-be-calculator]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kayttopaaomalaskuri"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseFinnishNumber = (value) => {
      const cleaned = String(value)
        .trim()
        .replace(/\s|\u00a0/g, "")
        .replace(/[€%]/g, "");

      if (!cleaned) return NaN;

      const commaIndex = cleaned.lastIndexOf(",");
      const dotIndex = cleaned.lastIndexOf(".");
      let normalized = cleaned;

      if (commaIndex > -1 && dotIndex > -1) {
        const decimalSeparator = commaIndex > dotIndex ? "," : ".";
        const thousandsSeparator = decimalSeparator === "," ? /\./g : /,/g;
        normalized = normalized.replace(thousandsSeparator, "");
        normalized = normalized.replace(decimalSeparator, ".");
      } else if (commaIndex > -1) {
        const commaCount = (cleaned.match(/,/g) || []).length;
        normalized = commaCount > 1
          ? cleaned.replace(/,/g, "")
          : cleaned.replace(",", ".");
      } else if (dotIndex > -1) {
        const dotCount = (cleaned.match(/\./g) || []).length;
        normalized = dotCount > 1 ? cleaned.replace(/\./g, "") : cleaned;
      }

      return Number(normalized);
    };

    const euro = new Intl.NumberFormat("fi-FI", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0
    });

    const decimal = new Intl.NumberFormat("fi-FI", {
      maximumFractionDigits: 1
    });

    const init = (root) => {
      if (root.dataset.initialized === "true") return;
      root.dataset.initialized = "true";

      const form = root.querySelector("[data-form]");
      const error = root.querySelector("[data-error]");
      const resultHeading = root.querySelector("[data-result-heading]");
      const resultLead = root.querySelector("[data-result-lead]");
      const metrics = root.querySelector("[data-metrics]");
      const interpretation = root.querySelector("[data-interpretation]");

      const showError = (message) => {
        error.textContent = message;
        error.hidden = false;
      };

      form.addEventListener("submit", (event) => {
        event.preventDefault();
        error.hidden = true;

        const annualSales = parseFinnishNumber(root.querySelector("[data-annual-sales]").value);
        const vatRate = parseFinnishNumber(root.querySelector("[data-vat-rate]").value);
        const currentDays = parseFinnishNumber(root.querySelector("[data-current-days]").value);
        const targetDays = parseFinnishNumber(root.querySelector("[data-target-days]").value);

        if (![annualSales, vatRate, currentDays, targetDays].every(Number.isFinite)) {
          showError("Tarkista, että kaikki kentät sisältävät numeroarvon.");
          return;
        }
        if (annualSales <= 0) {
          showError("Vuosittaisen laskutusmyynnin pitää olla suurempi kuin nolla.");
          return;
        }
        if (vatRate < 0 || vatRate > 100) {
          showError("Arvonlisäverokannan pitää olla 0–100 prosenttia.");
          return;
        }
        if (currentDays < 0 || targetDays < 0 || currentDays > 365 || targetDays > 365) {
          showError("Kiertoaikojen pitää olla 0–365 päivää.");
          return;
        }

        const dailySales = annualSales / 365;
        const daysChange = currentDays - targetDays;
        const netImpact = dailySales * daysChange;
        const grossImpact = netImpact * (1 + vatRate / 100);
        const absoluteDays = Math.abs(daysChange);

        root.querySelector("[data-net-impact]").textContent = euro.format(Math.abs(netImpact));
        root.querySelector("[data-gross-impact]").textContent = euro.format(Math.abs(grossImpact));
        root.querySelector("[data-daily-sales]").textContent = euro.format(dailySales);
        root.querySelector("[data-days-change]").textContent =
          `${decimal.format(absoluteDays)} päivää`;

        let heading;
        let lead;
        let interpretationText;

        if (daysChange > 0) {
          heading = "Rahaa vapautuisi kassaan";
          lead = `Kun toteutunut kiertoaika lyhenee ${decimal.format(absoluteDays)} päivää, myyntisaamisiin sitoutunut pääoma pienenee.`;
          interpretationText =
            `Arvion mukaan myyntisaamisista vapautuisi ${euro.format(netImpact)} ilman arvonlisäveroa. ` +
            `Laskujen maksamisen bruttovaikutus kassaan olisi ajoitukseltaan noin ${euro.format(grossImpact)}.`;
        } else if (daysChange < 0) {
          heading = "Rahaa sitoutuisi lisää";
          lead = `Kun toteutunut kiertoaika pitenee ${decimal.format(absoluteDays)} päivää, myyntisaamisiin sitoutunut pääoma kasvaa.`;
          interpretationText =
            `Arvion mukaan myyntisaamisiin sitoutuisi lisää ${euro.format(Math.abs(netImpact))} ilman arvonlisäveroa. ` +
            `Laskujen maksamisen bruttovaikutus kassaan olisi ajoitukseltaan noin ${euro.format(Math.abs(grossImpact))}.`;
        } else {
          heading = "Kiertoaika ei muutu";
          lead = "Nykyinen ja tavoiteltu kiertoaika ovat samat.";
          interpretationText = "Kiertoaikojen perusteella käyttöpääomaan tai kassaan ei syntyisi muutosta.";
        }

        resultHeading.textContent = heading;
        resultLead.textContent = lead;
        interpretation.textContent = interpretationText;
        metrics.hidden = false;
        interpretation.hidden = false;

        if (window.innerWidth < 801) {
          root.querySelector("[data-result]").scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll("[data-wc-calculator]").forEach(init);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initAll());
    } else {
      initAll();
    }

    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["malliraportti"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-tkm-toggle]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
    if (!open) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      var field = panel.querySelector('input, select, textarea, button');
      if (field) { try { field.focus({ preventScroll: true }); } catch (e) {} }
    }
  });
});
document.querySelectorAll('[data-tkm-scroll]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var id = a.getAttribute('href');
    var t = id && id.charAt(0) === '#' ? document.querySelector(id) : null;
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rekrytointi"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const form = root.querySelector('[data-form]');
      const error = root.querySelector('[data-error]');
      const metrics = root.querySelector('[data-metrics]');
      const interpretation = root.querySelector('[data-interpretation]');
      const euro = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
      const decimal = new Intl.NumberFormat('fi-FI', { maximumFractionDigits: 1 });

      const parseNumber = (value) => {
        const cleaned = String(value).trim().replace(/\s/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
        return Number(cleaned);
      };

      const setText = (selector, value) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = value;
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const salary = parseNumber(root.querySelector('[data-salary]').value);
        const sideCostsRate = parseNumber(root.querySelector('[data-side-costs]').value);
        const otherCosts = parseNumber(root.querySelector('[data-other-costs]').value);
        const oneTimeCosts = parseNumber(root.querySelector('[data-one-time-costs]').value);
        const marginRate = parseNumber(root.querySelector('[data-margin]').value);
        const addedSales = parseNumber(root.querySelector('[data-added-sales]').value);
        const rampMonths = parseNumber(root.querySelector('[data-ramp-months]').value);

        if (![salary, sideCostsRate, otherCosts, oneTimeCosts, marginRate, addedSales, rampMonths].every(Number.isFinite)) {
          error.textContent = 'Tarkista syöttämäsi luvut. Käytä vain numeroita.';
          error.hidden = false;
          return;
        }
        if (salary <= 0) {
          error.textContent = 'Kuukausipalkan pitää olla suurempi kuin 0.';
          error.hidden = false;
          return;
        }
        if (sideCostsRate < 0 || sideCostsRate > 200 || otherCosts < 0 || oneTimeCosts < 0 || addedSales < 0) {
          error.textContent = 'Tarkista kustannukset ja lisämyynti. Arvot eivät voi olla negatiivisia.';
          error.hidden = false;
          return;
        }
        if (marginRate <= 0 || marginRate > 100) {
          error.textContent = 'Katetuottoprosentin pitää olla suurempi kuin 0 ja enintään 100.';
          error.hidden = false;
          return;
        }
        if (rampMonths < 0 || rampMonths > 12) {
          error.textContent = 'Täyteen tuottavuuteen kuluvan ajan pitää olla 0–12 kuukautta.';
          error.hidden = false;
          return;
        }
        error.hidden = true;

        const monthlyCost = salary * (1 + sideCostsRate / 100) + otherCosts;
        const requiredSales = monthlyCost / (marginRate / 100);
        const monthlyContribution = addedSales * (marginRate / 100);
        const monthlyResult = monthlyContribution - monthlyCost;
        const productiveMonths = 12 - rampMonths;
        const firstYearResult = monthlyContribution * productiveMonths - monthlyCost * 12 - oneTimeCosts;
        const rampInvestment = oneTimeCosts + monthlyCost * rampMonths;
        const salesGap = addedSales - requiredSales;

        setText('[data-monthly-cost]', euro.format(monthlyCost));
        setText('[data-required-sales]', euro.format(requiredSales));
        setText('[data-monthly-result]', euro.format(monthlyResult));
        setText('[data-first-year-result]', euro.format(firstYearResult));

        if (Math.abs(monthlyResult) < 0.5) {
          setText('[data-result-heading]', 'Rekrytointi on kannattavuusrajalla');
          interpretation.innerHTML =
            `Arvioitu lisämyynti kattaa jatkuvat kustannukset täyden tuottavuuden saavuttamisen jälkeen. ` +
            `Ensimmäisten 12 kuukauden tulosvaikutus on arviolta <strong>${euro.format(firstYearResult)}</strong>, ` +
            `kun perehdytysajan myyntiä ei huomioida.`;
        } else if (monthlyResult > 0) {
          const paybackMonths = rampMonths + rampInvestment / monthlyResult;
          setText('[data-result-heading]', 'Rekrytointi ylittää kannattavuusrajan');
          interpretation.innerHTML =
            `Arvioitu lisämyynti ylittää kannattavuusrajan <strong>${euro.format(salesGap)}</strong> kuukaudessa. ` +
            `Alkuinvestointi ja tuottavuuteen pääsyn aika huomioiden takaisinmaksuajaksi muodostuu noin ` +
            `<strong>${decimal.format(paybackMonths)} kuukautta</strong> rekrytoinnin alusta. ` +
            `Ensimmäisten 12 kuukauden tulosvaikutus on arviolta <strong>${euro.format(firstYearResult)}</strong>.`;
        } else {
          setText('[data-result-heading]', 'Rekrytointi ei vielä kata kustannuksiaan');
          interpretation.innerHTML =
            `Arvioitu lisämyynti jää kannattavuusrajasta <strong>${euro.format(Math.abs(salesGap))}</strong> kuukaudessa. ` +
            `Näillä oletuksilla rekrytointi ei maksa itseään takaisin. Ensimmäisten 12 kuukauden tulosvaikutus on ` +
            `arviolta <strong>${euro.format(firstYearResult)}</strong>.`;
        }
        interpretation.hidden = false;
        metrics.hidden = false;

        root.dispatchEvent(new CustomEvent('pahkamaa:calculator-used', {
          bubbles: true,
          detail: { calculator: 'rekrytointilaskuri' }
        }));
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-recruitment-calculator]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talousjohtamisen-testi"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const QUESTIONS = [
      {
        text: "Onko yrityksellä vähintään 13 viikon kassavirtaennuste?",
        category: "cash"
      },
      {
        text: "Tiedätkö kassan alimman ennustetun pisteen?",
        category: "cash"
      },
      {
        text: "Pystytkö arvioimaan, miten 10 prosentin myynnin lasku vaikuttaisi kassaan ja käyttökatteeseen?",
        category: "profit"
      },
      {
        text: "Tunnetaanko tuotteiden, palvelujen tai projektien todellinen kate?",
        category: "profit"
      },
      {
        text: "Seurataanko myyntisaamisten ja ostovelkojen kiertoaikoja?",
        category: "cash"
      },
      {
        text: "Päivitetäänkö ennustetta säännöllisesti toteutuneiden lukujen perusteella?",
        category: "forecast"
      },
      {
        text: "Johtavatko talousraportit sovittuihin päätöksiin ja toimenpiteisiin?",
        category: "management"
      },
      {
        text: "Tunnetaanko suurimpien asiakkaiden merkitys liikevaihdolle, katteelle ja kassavirralle?",
        category: "profit"
      },
      {
        text: "Onko yritykselle määritelty hälytysrajat esimerkiksi kassalle, käyttökatteelle ja omavaraisuudelle?",
        category: "forecast"
      },
      {
        text: "Onko taloudellisen tiedon tuottamisesta, analysoinnista ja toimenpiteistä sovittu selkeät vastuut?",
        category: "management"
      }
    ];

    const ANSWERS = [
      { label: "Kyllä", value: 2 },
      { label: "Osittain", value: 1 },
      { label: "Ei", value: 0 }
    ];

    const CATEGORIES = {
      cash: {
        name: "Kassavirta ja käyttöpääoma",
        strong: "Yrityksessä seurataan kassaa ja käyttöpääomaa suhteellisen järjestelmällisesti.",
        weak: "Rakenna vähintään 13 viikon kassavirtaennuste ja tunnista kassan alin piste.",
        action: "Laadi 13 viikon kassavirtaennuste ja määritä kassan vähimmäistaso."
      },
      profit: {
        name: "Kannattavuus ja liiketoimintariskit",
        strong: "Yrityksessä tunnetaan kannattavuuden ajurit ja keskeisiä liiketoimintariskejä.",
        weak: "Tarkenna tuotteiden, palvelujen tai projektien kate sekä suurimpien asiakkaiden taloudellinen merkitys.",
        action: "Laske kate päätöksenteon kannalta olennaisella tasolla ja arvioi suurimman asiakkuuden riski."
      },
      forecast: {
        name: "Ennustaminen ja hälytysrajat",
        strong: "Tulevaa arvioidaan ja taloudelle on määritelty ennakoivia mittareita.",
        weak: "Ota käyttöön säännöllisesti päivitettävä ennuste ja sovi talouden hälytysrajat.",
        action: "Määritä kassalle, käyttökatteelle ja vakavaraisuudelle seurattavat hälytysrajat."
      },
      management: {
        name: "Raportointi, päätökset ja vastuut",
        strong: "Taloustieto kytkeytyy päätöksiin ja vastuista on sovittu.",
        weak: "Sovi, kuka analysoi luvut, kuka päättää toimenpiteistä ja miten toteutumista seurataan.",
        action: "Liitä jokaiseen talousraporttiin päätös, vastuuhenkilö ja määräaika."
      }
    };

    const init = (root) => {
      if (root.dataset.initialized === "true") return;
      root.dataset.initialized = "true";

      const views = {
        intro: root.querySelector('[data-view="intro"]'),
        questions: root.querySelector('[data-view="questions"]'),
        result: root.querySelector('[data-view="result"]')
      };
      const questionWrap = root.querySelector("[data-question-wrap]");
      const nextButton = root.querySelector("[data-next]");
      const backButton = root.querySelector("[data-back]");
      const answers = new Array(QUESTIONS.length).fill(null);
      let current = 0;

      const showView = (name) => {
        Object.entries(views).forEach(([key, element]) => {
          element.hidden = key !== name;
        });
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      };

      const renderQuestion = () => {
        const question = QUESTIONS[current];
        const progress = Math.round(((current + 1) / QUESTIONS.length) * 100);

        root.querySelector("[data-progress-text]").textContent =
          `Kysymys ${current + 1}/${QUESTIONS.length}`;
        root.querySelector("[data-progress-percent]").textContent = `${progress} %`;
        root.querySelector("[data-progress]").setAttribute("aria-valuenow", current + 1);
        root.querySelector("[data-progress-bar]").style.width = `${progress}%`;

        questionWrap.innerHTML = "";

        const category = document.createElement("span");
        category.className = "finance-test__question-category";
        category.textContent = CATEGORIES[question.category].name;

        const heading = document.createElement("h2");
        heading.className = "finance-test__question";
        heading.id = `finance-question-${root.id}-${current}`;
        heading.textContent = question.text;

        const answerGroup = document.createElement("div");
        answerGroup.className = "finance-test__answers";
        answerGroup.setAttribute("role", "group");
        answerGroup.setAttribute("aria-labelledby", heading.id);

        ANSWERS.forEach((answer) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "finance-test__answer";
          button.textContent = answer.label;
          button.dataset.value = answer.value;
          button.setAttribute("aria-pressed", answers[current] === answer.value ? "true" : "false");
          button.addEventListener("click", () => {
            answers[current] = answer.value;
            answerGroup.querySelectorAll(".finance-test__answer").forEach((item) => {
              item.setAttribute("aria-pressed", item === button ? "true" : "false");
            });
            nextButton.disabled = false;
          });
          answerGroup.appendChild(button);
        });

        questionWrap.append(category, heading, answerGroup);
        backButton.style.visibility = current === 0 ? "hidden" : "visible";
        nextButton.disabled = answers[current] === null;
        nextButton.textContent = current === QUESTIONS.length - 1 ? "Näytä tulos" : "Seuraava";
      };

      const categoryPercentages = () => {
        const totals = {};
        Object.keys(CATEGORIES).forEach((key) => {
          totals[key] = { score: 0, maximum: 0 };
        });
        QUESTIONS.forEach((question, index) => {
          totals[question.category].score += answers[index];
          totals[question.category].maximum += 2;
        });
        return Object.fromEntries(
          Object.entries(totals).map(([key, value]) => [
            key,
            value.maximum ? value.score / value.maximum : 0
          ])
        );
      };

      const renderResult = () => {
        const score = answers.reduce((sum, value) => sum + value, 0);
        const percentages = categoryPercentages();
        const ordered = Object.entries(percentages).sort((a, b) => b[1] - a[1]);
        const strongestKey = ordered[0][0];
        const weakestKey = ordered[ordered.length - 1][0];

        let title;
        let summary;
        if (score <= 7) {
          title = "Taloutta johdetaan pääosin jälkikäteen";
          summary =
            "Yrityksellä voi olla kirjanpidon tuottamaa tietoa, mutta ennakointi ja päätöksenteon tuki ovat vielä puutteellisia. Keskeinen riski on, että kassa- tai kannattavuusongelma havaitaan vasta sen jo toteuduttua.";
        } else if (score <= 14) {
          title = "Perusta on olemassa, mutta näkyvyydessä on aukkoja";
          summary =
            "Yrityksessä seurataan taloutta, mutta kassavirran ennustaminen, kannattavuuden erittely tai toimenpiteiden seuranta ei vielä muodosta yhtenäistä johtamisjärjestelmää.";
        } else {
          title = "Talouden johtamisen perusta on vahva";
          summary =
            "Yrityksellä on hyvät edellytykset ennakoivaan talousjohtamiseen. Seuraava kehitysvaihe voi olla skenaarioiden, automaation, projektikannattavuuden tai päätöksenteon mittareiden syventäminen.";
        }

        root.querySelector("[data-score]").textContent = `${score}/20 pistettä`;
        root.querySelector("[data-result-title]").textContent = title;
        root.querySelector("[data-result-summary]").textContent = summary;
        root.querySelector("[data-strength-title]").textContent = CATEGORIES[strongestKey].name;
        root.querySelector("[data-strength-text]").textContent = CATEGORIES[strongestKey].strong;
        root.querySelector("[data-development-title]").textContent = CATEGORIES[weakestKey].name;
        root.querySelector("[data-development-text]").textContent = CATEGORIES[weakestKey].weak;

        const recommendationKeys = [
          weakestKey,
          ...ordered
            .slice()
            .reverse()
            .map(([key]) => key)
            .filter((key) => key !== weakestKey)
        ].slice(0, 3);
        const list = root.querySelector("[data-recommendations]");
        list.innerHTML = "";
        recommendationKeys.forEach((key) => {
          const item = document.createElement("li");
          item.textContent = CATEGORIES[key].action;
          list.appendChild(item);
        });

        showView("result");
      };

      root.querySelector("[data-start]").addEventListener("click", () => {
        current = 0;
        renderQuestion();
        showView("questions");
      });

      nextButton.addEventListener("click", () => {
        if (answers[current] === null) return;
        if (current < QUESTIONS.length - 1) {
          current += 1;
          renderQuestion();
        } else {
          renderResult();
        }
      });

      backButton.addEventListener("click", () => {
        if (current > 0) {
          current -= 1;
          renderQuestion();
        }
      });

      root.querySelector("[data-restart]").addEventListener("click", () => {
        answers.fill(null);
        current = 0;
        renderQuestion();
        showView("intro");
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll("[data-finance-test]").forEach(init);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initAll());
    } else {
      initAll();
    }

    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
